'use client';

import { c as _c } from "react/compiler-runtime";
import { useState, useCallback, useEffect, useRef } from 'react';
interface UseResizableOptions {
  defaultWidth: number;
  minWidth: number;
  maxWidthRatio: number; // Max width as ratio of viewport (e.g., 0.33 for 1/3)
  storageKey?: string;
  direction?: 'left' | 'right'; // Which side the resize handle is on
}
export function useResizable(t0) {
  const $ = _c(26);
  const {
    defaultWidth,
    minWidth,
    maxWidthRatio,
    storageKey,
    direction: t1
  } = t0;
  const direction = t1 === undefined ? "left" : t1;
  const [width, setWidth] = useState(defaultWidth);
  const [isResizing, setIsResizing] = useState(false);
  const startXRef = useRef(0);
  const startWidthRef = useRef(0);
  let t2;
  let t3;
  if ($[0] !== maxWidthRatio || $[1] !== minWidth || $[2] !== storageKey) {
    t2 = () => {
      if (storageKey && typeof window !== "undefined") {
        const saved = localStorage.getItem(storageKey);
        if (saved) {
          const parsed = parseInt(saved, 10);
          if (!isNaN(parsed)) {
            const maxWidth = window.innerWidth * maxWidthRatio;
            setWidth(Math.min(Math.max(parsed, minWidth), maxWidth));
          }
        }
      }
    };
    t3 = [storageKey, minWidth, maxWidthRatio];
    $[0] = maxWidthRatio;
    $[1] = minWidth;
    $[2] = storageKey;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[5] !== isResizing || $[6] !== storageKey || $[7] !== width) {
    t4 = () => {
      if (storageKey && typeof window !== "undefined" && !isResizing) {
        localStorage.setItem(storageKey, width.toString());
      }
    };
    t5 = [width, storageKey, isResizing];
    $[5] = isResizing;
    $[6] = storageKey;
    $[7] = width;
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[10] !== maxWidthRatio || $[11] !== minWidth) {
    t6 = () => {
      const handleWindowResize = () => {
        const maxWidth_0 = window.innerWidth * maxWidthRatio;
        setWidth(prev => Math.min(Math.max(prev, minWidth), maxWidth_0));
      };
      window.addEventListener("resize", handleWindowResize);
      return () => window.removeEventListener("resize", handleWindowResize);
    };
    t7 = [minWidth, maxWidthRatio];
    $[10] = maxWidthRatio;
    $[11] = minWidth;
    $[12] = t6;
    $[13] = t7;
  } else {
    t6 = $[12];
    t7 = $[13];
  }
  useEffect(t6, t7);
  let t8;
  if ($[14] !== width) {
    t8 = e => {
      e.preventDefault();
      setIsResizing(true);
      startXRef.current = e.clientX;
      startWidthRef.current = width;
    };
    $[14] = width;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const startResize = t8;
  let t10;
  let t9;
  if ($[16] !== direction || $[17] !== isResizing || $[18] !== maxWidthRatio || $[19] !== minWidth) {
    t9 = () => {
      if (!isResizing) {
        return;
      }
      const handleMouseMove = e_0 => {
        const maxWidth_1 = window.innerWidth * maxWidthRatio;
        const delta = direction === "left" ? startXRef.current - e_0.clientX : e_0.clientX - startXRef.current;
        const newWidth = Math.min(Math.max(startWidthRef.current + delta, minWidth), maxWidth_1);
        setWidth(newWidth);
      };
      const handleMouseUp = () => {
        setIsResizing(false);
      };
      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", handleMouseUp);
      document.body.style.cursor = "col-resize";
      document.body.style.userSelect = "none";
      return () => {
        document.removeEventListener("mousemove", handleMouseMove);
        document.removeEventListener("mouseup", handleMouseUp);
        document.body.style.cursor = "";
        document.body.style.userSelect = "";
      };
    };
    t10 = [isResizing, minWidth, maxWidthRatio, direction];
    $[16] = direction;
    $[17] = isResizing;
    $[18] = maxWidthRatio;
    $[19] = minWidth;
    $[20] = t10;
    $[21] = t9;
  } else {
    t10 = $[20];
    t9 = $[21];
  }
  useEffect(t9, t10);
  let t11;
  if ($[22] !== isResizing || $[23] !== startResize || $[24] !== width) {
    t11 = {
      width,
      isResizing,
      startResize,
      setWidth
    };
    $[22] = isResizing;
    $[23] = startResize;
    $[24] = width;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  return t11;
}